import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar";

const JobSupportLayout = () => {
  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};

export default JobSupportLayout;
